// extracted by mini-css-extract-plugin
module.exports = {"trigger":"WidgetTrigger_trigger__3fH4L","trigger_middleLeft":"WidgetTrigger_trigger_middleLeft__73--F","trigger_middleRight":"WidgetTrigger_trigger_middleRight__1zyZC"};